import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ClosePopupPage = () => {
  useEffect(() => {
    window.close();
  }, []);

  return <></>;
};

export default ClosePopupPage;
